import Vue from 'vue';
import VueRouter from 'vue-router';
import {Role} from '../utils/role';
import {
    name,
    path
} from '../utils/general/routers';
import {rolesAll} from '../utils/general/roles';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true},
        children: [
            {
                path: path.dashboard,
                name: name.dashboard,
                component: () => import('../components/dashboard/index')
            },
            {path: '', redirect: path.organisationList}
        ]
    },
    {
        path: '/' + path.settings,
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true, authorize: [Role.Admin]},
        children: [
            {
                path: path.domainList,
                name: name.domainList,
                component: () => import('../components/settings/domains/Index'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.domainAdd,
                name: name.domainAdd,
                component: () => import('../components/settings/domains/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.domainUpdate + '/:domainId',
                name: name.domainUpdate,
                component: () => import('../components/settings/domains/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.moduleList,
                name: name.moduleList,
                component: () => import('../components/settings/modules/Index'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.moduleAdd,
                name: name.moduleAdd,
                component: () => import('../components/settings/modules/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.moduleUpdate + '/:moduleId',
                name: name.moduleUpdate,
                component: () => import('../components/settings/modules/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.typePackList,
                name: name.typePackList,
                component: () => import('../components/settings/typePacks/Index'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.typePackAdd,
                name: name.typePackAdd,
                component: () => import('../components/settings/typePacks/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.typePackUpdate + '/:typePackId',
                name: name.typePackUpdate,
                component: () => import('../components/settings/typePacks/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.functionalityList,
                name: name.functionalityList,
                component: () => import('../components/settings/functionalities/Index'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.functionalityAdd,
                name: name.functionalityAdd,
                component: () => import('../components/settings/functionalities/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.functionalityUpdate + '/:functionalityId',
                name: name.functionalityUpdate,
                component: () => import('../components/settings/functionalities/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.packList,
                name: name.packList,
                component: () => import('../components/settings/packs/PackConfig'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.packUpdate,
                name: name.packUpdate,
                component: () => import('../components/settings/packs/PackForm'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            }
        ]
    },
    {
        path: '/invite/validateUser/:state/:idSelectedDomain?/:idSelectedPack?/:token',
        component: () => import('../components/validateUser/Index')
    },
    {
        path: '/' + path.network,
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true, authorize: [Role.Admin]},
        children: [

            {
                path: path.clientList,
                name: name.clientList,
                component: () => import('../components/network/clients/Index'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.clientAdd,
                name: name.clientAdd,
                component: () => import('../components/network/clients/Form'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.clientUpdate + '/:id',
                name: name.clientUpdate,
                component: () =>
                    import('../components/network/clients/Form'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.commercialList,
                name: name.commercialList,
                component: () => import('../components/network/commercials/Index'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.commercialAdd,
                name: name.commercialAdd,
                component: () => import('../components/network/commercials/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            },
            {
                path: path.commercialUpdate + '/:id',
                name: name.commercialUpdate,
                component: () =>
                    import('../components/network/commercials/Form'),
                meta: {requiresAuth: true, authorize: [Role.Admin]}
            }
        ]
    },
    {
        path: '/',
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true, authorize: rolesAll},
        children: [
            {
                path: path.organisationList,
                name: name.organisationList,
                component: () => import('../components/organisations/Index'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.organisationAdd,
                name: name.organisationAdd,
                component: () => import('../components/organisations/Form'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.organisationUpdate + '/:organisationId',
                name: name.organisationUpdate,
                component: () => import('../components/organisations/Form'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.organisationPayment + '/:id',
                name: name.payment,
                component: () => import('../components/payment/Index'),
                meta: {requiresAuth: true, authorize: rolesAll}
            },
            {
                path: path.organisationPayment + '/:id',
                name: name.paymentStep,
                component: () => import('../components/payment/Payment'),
                meta: {requiresAuth: true, authorize: rolesAll}
            }
        ]
    },
    {
        path: '/',
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true, authorize: rolesAll},
        children: [
            {
                path: path.profile,
                component: () => import('../components/profile/Index'),
                meta: {
                    requiresAuth: true,
                    authorize: rolesAll
                }
            }
        ]
    },
    {
        path: '/',
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true, authorize: rolesAll},
        children: [
            {
                path: path.logs,
                name: name.logs,
                component: () => import('../components/logs/Logs'),
                meta: {
                    requiresAuth: true,
                    authorize: rolesAll
                }
            }
        ]
    },
    {
        path: '/' + path.support,
        name: name.support,
        component: () => import('../components/layouts/AppLayout'),
        meta: {requiresAuth: true},
        children: [
            {
                path: 'inbox',
                component: () => import('../components/support/inbox/index.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('../components/support/inbox/all-messages')
                    },
                    {
                        path: 'read',
                        component: () => import('../components/support/inbox/opened-messages')
                    },
                    {
                        path: 'unread',
                        component: () => import('../components/support/inbox/unread-messages')
                    },
                    {
                        path: 'saved',
                        component: () => import('../components/support/inbox/saved-messages')
                    },
                    {
                        path: 'sent',
                        component: () => import('../components/support/inbox/sent-messages')
                    },
                    {
                        path: ':id',
                        component: () => import('../components/support/inbox/read-message')
                    }
                ]
            }
        ]
    },
    {
        path: '/auth',
        name: 'auth',
        component: () => import('../components/authentication/layouts/authLayout'),
        meta: {requiresAuth: false},
        children: [
            {
                path: 'login/:idSelectedDomain?/:idSelectedPack?',
                name: 'login',
                component: () => import('../components/authentication/loginPage/index')
            },
            {
                path: 'login/:token',
                name: 'login',
                component: () => import('../components/authentication/loginPage/index')
            },
            {
                path: 'recovery-code',
                name: 'recoveryCode',
                component: () =>
                    import('../components/authentication/recoveryCodePage/index')
            },
            {
                path: 'reset-password',
                name: 'resetPassword',
                component: () => import('../components/authentication/resetPassword/index')
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

function isAuthenticated() {
    let isAuthenticated = false;
    if (Vue.$cookies.get('token')) {
        isAuthenticated = true;
    }
    return isAuthenticated;
}

function getRole() {
    return Vue.$cookies.get('user').roles.length
        ? Vue.$cookies.get('user').roles[0]
        : Vue.$cookies.get('user').roles;
}

router.beforeResolve((to, from, next) => {
    if (to.matched.some(m => m.meta.requiresAuth) && !isAuthenticated()) {
        next({
            name: 'login'
        });
    } else if (!to.matched.some(m => m.meta.requiresAuth) && isAuthenticated()) {
        next({
            path: '/'
        });
    } else if (
        to.matched.some(m => m.meta.authorize) &&
        !to.meta.authorize.includes(getRole())
    ) {
        next({
            name: '/'
        });
    } else {
        next();
    }
});

export default router;
